import { CellType } from './cell'
import { LineStyle, LineWidth, lineAppearance } from '../lineAppearance'
import {
  millisecondsToMinutes,
} from 'common/utils/time'

const layoverCellFromTicketsHop = (response, leg, relativeHopIndex) => {
  if (!leg.layovers) {
    throw Error(
      'Can\'t create a LayoverCell from a leg with no layovers. leg.layovers === undefined.'
    )
  }

  const layoverIndex = leg.layovers[relativeHopIndex]
  const layover = response.layovers[layoverIndex]

  const hopIndex = leg.hops[relativeHopIndex]
  const hop = response.hops[hopIndex]
  const line = response.lines[hop.line]
  const placeIndex = line.places[line.places.length - 1]
  const place = response.places[placeIndex]
  const vehicle = response.vehicles[hop.vehicle]
  const isSurface = vehicle.kind !== 'plane'

  const oneHourInMinutes = 60
  const longLayoverDuration = isSurface ? oneHourInMinutes : 4 * oneHourInMinutes
  const durationInMinutes = layover.duration
  const isLongLayover = durationInMinutes >= longLayoverDuration
  const dayChange = layover.dayChange !== undefined ? layover.dayChange : 0
  const isOvernight = dayChange > 0

  return {
    type: CellType.Interchange,
    isSurface,
    place: place.name,
    isOvernight,
    isLongLayover,
    durationInMinutes,
    line: lineAppearance(LineStyle.Dotted, LineWidth.Regular, 'light-grey'),
  }
}

const layoverCellFromTicketsLeg = (response, itinerary, relativeLegIndex) => {
  if (!itinerary.layovers) {
    throw Error(
      'Can\'t create a LayoverCell from a leg with no layovers. leg.layovers === undefined.'
    )
  }

  const layoverIndex = itinerary.layovers[relativeLegIndex]
  const layover = response.layovers[layoverIndex]

  const legIndex = itinerary.legs[relativeLegIndex]
  const leg = response.legs[legIndex]

  const lastHopIndex = leg.hops[leg.hops.length - 1]
  const lastHop = response.hops[lastHopIndex]
  const line = response.lines[lastHop.line]
  const placeIndex = line.places[line.places.length - 1]
  const place = response.places[placeIndex]
  const vehicle = response.vehicles[lastHop.vehicle]

  const isSurface = vehicle.kind !== 'plane'
  const oneHourInMinutes = 60
  const longLayoverDuration = isSurface ? oneHourInMinutes : 4 * oneHourInMinutes
  const durationInMinutes = layover.duration
  const isLongLayover = durationInMinutes >= longLayoverDuration
  const dayChange = layover.dayChange !== undefined ? layover.dayChange : 0
  const isOvernight = dayChange > 0

  return {
    type: CellType.Interchange,
    isSurface,
    place: place.name,
    isOvernight,
    isLongLayover,
    durationInMinutes,
    line: lineAppearance(LineStyle.Dotted, LineWidth.Regular, 'light-grey'),
  }
}

const layoverCellFromCheckoutHop = (hop, isOvernight) => {
  const isSurface = hop.kind != 'plane'
  const durationInMinutes = millisecondsToMinutes(hop.waitTimeAtOrigin)

  const oneHourInMinutes = 60
  const longLayoverDuration = isSurface ? oneHourInMinutes : 4 * oneHourInMinutes
  const isLongLayover = durationInMinutes >= longLayoverDuration

  return {
    type: CellType.Interchange,
    isSurface,
    place: hop.origin,
    isOvernight,
    isLongLayover,
    durationInMinutes,
    line: lineAppearance(LineStyle.Dotted, LineWidth.Regular, 'light-grey'),
  }
}

export {
  layoverCellFromTicketsHop,
  layoverCellFromTicketsLeg,
  layoverCellFromCheckoutHop,
}
